const turnoverCoordinates = {
  info: [

    {
      name: 'A&W Restaurant',
      status: 'closed',
      approximateDate: 'November 2020',
      address: '2996 Telegraph Avenue',
      coordinates: [37.856733277598124, -122.25983728206509],
      note: 'Aliberto’s Jr. Mexican Food opened at this address in June 2022.',
      color: '#6e82b7',
    },
    {
      name: "Bill's Men's Shop",
      status: 'closed',
      approximateDate: 'October 2020',
      address: '2386 Telegraph Avenue',
      coordinates: [37.867083, -122.258984],
      note: "Sold and replaced by Beck's Shoes in October 2020 due to business owner's retirement.",
      color: '#e3565f',
    },
    {
      name: 'Boileroom and Sojo Ramen',
      status: 'closed',
      approximateDate: 'April 2020 and February 2022',
      address: '2475 Telegraph Avenue',
      coordinates: [37.865601617363396, -122.2582947500843],
      note: 'Boileroom closed in support of California shelter-in-place order. Sojo Ramen opened in the months following, but closed in February 2022. Sizzling Lunch opened at this address in February 2022.',
      color: '#6e82b7',
    },
    {
      name: 'Buffalo Exchange',
      status: 'closed',
      approximateDate: 'November 2020',
      address: '2585 Telegraph Avenue',
      coordinates: [37.863792, -122.258421],
      note: null,
      color: '#e3565f',
    },
    {
      name: 'Daiso',
      status: 'closed',
      approximateDate: 'June 2020',
      address: '2369 Telegraph Avenue',
      coordinates: [37.867295, -122.258743],
      note: 'Mosaic Boulders opened at this address in September 2022.',
      color: '#6e82b7',
    },
    {
      name: 'Finfine',
      status: 'closed',
      approximateDate: 'March 2020',
      address: '2556 Telegraph Avenue',
      coordinates: [37.8641396671781, -122.25894226246976],
      note: 'closed for shelter-in-place order and demolition of The Village mall. Business owners are looking to re-open in Berkeley.',
      color: '#e3565f',
    },
    {
      name: 'J-Town Express',
      status: 'closed',
      approximateDate: 'December 2020',
      address: '2332 Telegraph Avenue',
      coordinates: [37.868197, -122.259194],
      note: null,
      color: '#e3565f',
    },
    {
      name: 'Tako Sushi',
      status: 'closed',
      approximateDate: 'May 2022',
      address: '2379 Telegraph Avenue',
      coordinates: [37.867112, -122.258614],
      note: null,
      color: '#e3565f',
    },
    {
      name: 'Enedina Taqueria',
      status: 'closed',
      approximateDate: 'June 2021',
      address: '3001 Telegraph Avenue',
      coordinates: [37.855895645218915, -122.2593851832884],
      note: 'The Line Coffee opened at this address in April 2022.',
      color: '#6e82b7',
    },
    {
      name: 'So-so Supermarket',
      status: 'closed',
      approximateDate: 'December 2021',
      address: '2333 Telegraph Avenue',
      coordinates: [37.868222, -122.258936],
      note: 'Ran as a three-month-long pop up shop between September 2021 and December 2021.',
      color: '#e3565f',
    },
    {
      name: "Pappy's",
      status: 'closed',
      approximateDate: 'March 2022',
      address: '2367 Telegraph Avenue',
      coordinates: [37.867525167145544, -122.25874111775073],
      note: null,
      color: '#e3565f',
    },
    {
      name: 'Delhi Diner',
      status: 'opened',
      approximateDate: 'June 2020',
      address: '2400 Telegraph Avenue',
      coordinates: [37.86680686504661, -122.2589128022855],
      note: null,
      color: '#95c361',
    },
    {
      name: 'Diffusion Studios',
      status: 'opened',
      approximateDate: 'September 2021',
      address: '2315 Telegraph Avenue',
      coordinates: [37.868334749642386, -122.25897193555352],
      note: null,
      color: '#95c361',
    },
    {
      name: 'Duffl',
      status: 'opened',
      approximateDate: 'September 2021',
      address: '2595 Telegraph Avenue',
      coordinates: [37.8635543401126, -122.25840979908618],
      note: null,
      color: '#95c361',
    },
    {
      name: 'Kuboba Spot',
      status: 'opened',
      approximateDate: 'July 2022',
      address: '2618 Telegraph Avenue',
      coordinates: [37.86260092975001, -122.25903709983461],
      note: null,
      color: '#95c361',
    },
    {
      name: 'Sharetea',
      status: 'opened',
      approximateDate: 'October 2021',
      address: '2328 Telegraph Avenue',
      coordinates: [37.867968, -122.259194],
      note: null,
      color: '#95c361',
    },
    {
      name: 'The Apothecarium',
      status: 'opened',
      approximateDate: 'July 2020',
      address: '2312 Telegraph Avenue',
      coordinates: [37.86828126852266, -122.25934432821737],
      note: null,
      color: '#95c361',
    },
    {
      name: 'The Ink Stone',
      status: 'opened',
      approximateDate: 'June 2020',
      address: '2424 Telegraph Avenue',
      coordinates: [37.86652586892029, -122.25889479933339],
      note: 'Moved from 2302 Bowditch Street.',
      color: '#95c361',
    },

  ],
  minLat: 37.856888564930244,
  maxLat: 37.86763259068802,
  minLong: -122.26692349096834,
  maxLong: -122.24801314287727,
};

export default turnoverCoordinates;
